import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { COUPON_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_COUPON: (couponId) => ({ couponId }),
    API: {
      GET_COUPON: apiResourceActionCreator('coupon')
    }
  }
})

export const apiAction = (authToken, couponId) => commonApiActions.authenticated.get(COUPON_ENDPOINT(couponId), authToken, actions.payment.api.getCoupon)

export function* fetchCoupon(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.couponId));
  }
}

const configuration = {
  name: 'getCoupon',
  action: actions,
  sagas: fetchCoupon,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingCoupon: true,
      error: undefined,
      coupon: undefined,
    }),
    success: (state, action) => ({
      ...state,
      coupon: action.payload.coupon,
      isFetchingCoupon: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingCoupon: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getCoupon.js